// extracted by mini-css-extract-plugin
export default {"navigationButton":"FooterOnboardingNavigation_navigationButton__tX8Zo"};